import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import GlobalSearchMenu from './GlobalSearchMenu';
import {
  updateOrderSettingModalIsVisible,
  changePickUpLocationFromLocationsPage,
  updateInterOrderType,
  updateSelectedLocation,
} from '../../../OrderSetting/orderSettingActions';
import {getMenu} from '../../../OnAppLoad/Menu/menuActions';
import {getProductToConfigure} from '../../../ProductCustomizer/productCustomizerActions';
import {PICKUP, DELIVERY} from '../../../OrderSetting/orderSettingTypes';
import {connectStateResults} from 'react-instantsearch-dom';
import {emptyCart} from '../../../Cart/cartActions';

function GlobalSearchMenuContainer({
  productCustomizerReducer,
  orderSettingReducer,
  locationsReducer,
  menuReducer,
  cartReducer,
  getMenu,
  getProductToConfigure,
  updateInterOrderType,
  updateOrderSettingModalIsVisible,
  handleComboPreviewClick,
  changePickUpLocationFromLocationsPage,
  searchResults,
  refine,
  emptyCart,
  updateSelectedLocation,
}) {
  const {
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
    specialHours,
    orderSettingModalIsVisible,
  } = orderSettingReducer;
  const {locations} = locationsReducer;
  const {products} = menuReducer;

  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    if (interOrderType === PICKUP) {
      setSelectedLocation(interPickUpDetails);
    } else if (interOrderType === DELIVERY) {
      setSelectedLocation(
        interDeliveryDetails
          ? interDeliveryDetails.deliveryBusiness
            ? interDeliveryDetails.deliveryBusiness
            : interDeliveryDetails
          : interPickUpDetails
      );
    } else {
      setSelectedLocation(interDropOffDetails);
    }
  }, [
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
  ]);

  const {query, hits} = searchResults ? searchResults : {query: '', hits: []};

  return (
    <GlobalSearchMenu
      query={query}
      hits={hits}
      refine={refine}
      cart={cartReducer}
      locations={locations}
      products={products}
      specialHours={specialHours}
      selectedLocation={selectedLocation}
      emptyCart={() => emptyCart()}
      getMenu={(business_id, interOrderType) =>
        getMenu(business_id, interOrderType)
      }
      getProductToConfigure={productId => getProductToConfigure(productId)}
      updateOrderSettingModalIsVisible={bool =>
        updateOrderSettingModalIsVisible(bool)
      }
      changePickUpLocationFromLocationsPage={locationInfo =>
        changePickUpLocationFromLocationsPage(locationInfo)
      }
      updateInterOrderType={orderType => updateInterOrderType(orderType)}
      handleComboPreviewClick={handleComboPreviewClick}
      productCustomizerReducer={productCustomizerReducer}
      orderSettingModalIsVisible={orderSettingModalIsVisible}
      updateSelectedLocation={updateSelectedLocation}
      orderSettingReducer={orderSettingReducer}
    />
  );
}

const mapStateToProps = state => ({
  orderSettingReducer: state.orderSettingReducer,
  locationsReducer: state.locationsReducer,
  menuReducer: state.menuReducer,
  cartReducer: state.cartReducer,
  productCustomizerReducer: state.productCustomizerReducer,
});

export default connect(mapStateToProps, {
  getMenu,
  updateInterOrderType,
  updateOrderSettingModalIsVisible,
  changePickUpLocationFromLocationsPage,
  getProductToConfigure,
  emptyCart,
  updateSelectedLocation,
})(connectStateResults(GlobalSearchMenuContainer));
